import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { postRequest } from '../../../../helpers/request';
import { appApi } from '../../../../utils/endpoints/appApi';

import { onChangeStatus as onChangeStatusNotap, showStatusReConfirmFunc } from '../../../../config/redux/slice/notapUserSlice';
import { clearAll, setErrorMessageNotapUser, setLoadingNotapUser } from '../../../../config/redux/slice/notapUserSlice';
import { Spinner } from '../../../components'
import { showStatusChangeConfirmationFunc } from '../../../../config/redux/slice/notapUserSlice'
import { useForm } from 'react-hook-form'
import { truncateMiddle } from '../../../../helpers/helpers'
import Editor from '../../../components/Editor'

export default function StatusChangeConfirmation({status, btnText, certificateID}) {
    const dispatch = useDispatch()
    const {register, handleSubmit, setError, watch, getValues, setValue, formState: {errors}, reset} = useForm({mode: 'onTouched'})
    const {
        notapUserLoading,
        notapUserErrorMsg,
    } = useSelector((state) => state.notapUser)

    const statusValue = watch('status')

    const {
        certificateManagement:{showStatusReConfirm},
        evaluationManagement: {evaluationDetails}
    } = useSelector((state) => state.notapUser)

    const {
        token,
        userData: {user_role, isAdmin}
    } = useSelector((state) => state.authData)

    const [actionObj, setActionObj] = useState({})
    const [letter, setLetter]=useState(evaluationDetails.LETTER);
    const [formData, setFormData] = useState(new FormData());

    const  toolbarOptions  = {
        toolbar: [
            [{ font: [] }],
            [{ header: [1, 2, 3] }],
            ["bold", "italic", "underline","strike"],
            ["blockquote"],
            [{ list:  "ordered" }, { list:  "bullet" }],
            [{ indent:  "-1" }, { indent:  "+1" }, { align: [] }],
            ["link"],
            ["clean"],
        ],
    };

    const closeModal = () => {
        dispatch(clearAll({}))
        dispatch(showStatusChangeConfirmationFunc({ modal: false }));
    };

    const confirmAction = async (data) => {
        dispatch(clearAll({}))
        if(letter == ''){
          setError('letter', {type: 'manual', message:'Letter cannot be empty'})
        }else{
            data = {
              ...data,
              certificate_id: certificateID,
                comment_mode: 'EXTERNAL',
                comment: 'good',
                letter
            }
            for (let key in data){  
              if(typeof data[key] == "object"){
              if(data[key].length != 0){
                  formData.append(key, data[key][0])
                }
              } else{
                  formData.append(key, data[key])
              }
          }
           const res = await postRequest(
            token,
            `${appApi.notapChangeStatus}`,
            formData,
            dispatch,
            setLoadingNotapUser,
            "",
            setErrorMessageNotapUser
        )
        if(res != undefined && res.status < 400) {
          // dispatch(showStatusReConfirmFunc({modal: false}))
          dispatch(showStatusChangeConfirmationFunc({modal: false}))
          dispatch(onChangeStatusNotap({message: res.data.message, status: actionObj?.status}))
          setFormData(new FormData())
        } else{
          dispatch(showStatusReConfirmFunc({modal: false}))
          setFormData(new FormData())
        }  
          }   
    }

    function addFileName(e, idValue){
      let fileName = e.target.value;
      if(fileName !== ''){
        fileName = fileName.replace(/^.*[\\\/]/, '')
        document.getElementById(idValue).innerHTML = truncateMiddle(fileName, 50)
      }else{
        document.getElementById(idValue).innerHTML = "No file Chosen"
      }
    }

  return (
        <div 
        className="modal fade show" 
        id="basicModal" 
        tabIndex="-1"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
        style={{
          display: "block",
          backgroundColor: "rgba(0,0,0,0.3)",
          overflowY: 'auto'
        }}
     >
      {/* {showStatusReConfirm && <StatusChangeReConfirm actionObj={actionObj}/>} */}
  <div style={{overflowY: 'auto'}} className="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div className="modal-content">
    
    <form onSubmit={handleSubmit(confirmAction)} autoComplete={'off'} noValidate>
          <div className="modal-header px-4">
            <h5 className="modal-title" id="exampleModalCenterTitle">Send Letter to Bank Representative</h5>
            <button 
              type="button" 
              className="close" 
              data-dismiss="modal" 
              aria-label="Close"
              onClick={()=>{closeModal()}}
          >
            <span aria-hidden="true">×</span>
          </button>
          </div>
          <div className='modal-body'>
            {/* {isAdmin ?  */}
            {/* <div className={'px-sm-1 px-md-2 pb-2'}>
                <p style={{lineHeight: '2rem'}}>
                    Are you sure you want to change the status of this certificate?
                </p>
            </div> : */}
                <div className='form-group'>
                  <label htmlFor="certify_true_copy">Upload Certificate True Copy (CTC)</label>
                  <div>
                    <div className="custom-file mb-1">
                      <input 
                          type="file" 
                          className="custom-file-input" 
                          id="certify_true_copy"
                          {...register("certify_true_copy", {
                              required: {
                              value: statusValue == 'approved',
                              message: '*this field is required'
                              }
                          })
                          } 
                          onChange={(e) => {
                            addFileName(e, 'custom-certificate')
                          }}
                        
                      />
                      <label id="custom-certificate" className="custom-file-label">Choose file...</label>
                      {
                          errors?.certify_true_copy?.message &&
                          <div className="text-danger small mt-1">
                              {errors?.certify_true_copy?.message}
                          </div>
                          }
                    </div>
                  </div>
                </div>
                <div>
                  <label>Compose Letter</label>
                  <Editor value={letter} onChange={setLetter} />
                </div>
                  
                {
                  errors?.letter?.message &&
                  <div className="text-danger small mt-1">
                      {errors?.letter?.message}
                  </div>
                  }
            {/* <div className="form-group mt-3">
                <label htmlFor="comment">Comment</label>
                <textarea 
                style={{resize: 'none'}}
                    className="form-control" 
                    id="comment" 
                    rows="3"
                   {...register("comment", {
                    required: {
                    value: true,
                    message: '*this field is required'
                    }
                })
                }
                ></textarea>
                {
                    errors?.comment?.message &&
                    <div className="text-danger small mt-1">
                        {errors?.comment?.message}
                    </div>
                    }
            </div> */}
          </div>
        <div className="modal-footer px-4 d-flex align-items-center">
          {notapUserLoading ? 
              <Spinner/> :
              <>
            <div>
              <button onClick={()=>{
                setValue('status', 'disapproved')
                setValue('actionWord', 'reject')
              }
            } type="submit" className="btn btn-danger">Reject</button>
          </div>
            <div>
            {/* {notapUserLoading ? 
              <Spinner/> : */}
              <button onClick={()=>{
                setValue('status', 'approved')
                setValue('actionWord', 'approve')
              }} type="submit" className="btn btn-success">Approve</button>
            {/* } */}
          </div></>}
          </div>
    </form>
    </div>
  </div>
        </div>
  )
}
